<template>
	<CButton
		:disabled="disabled"
		type="submit"
		class="transparent"
		:color="color"
		data-test-id="button"
		@click.prevent="$emit('click')"
	>
		{{ text }}
	</CButton>
</template>

<script>
export default {
	name: 'BaseSaveButton',
	props: {
		text: {
			type: String,
			default: 'Save changes',
		},
		color: {
			type: String,
			default: 'primary',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

